{
  "defaultLockedAccount": {
    "electronicFundsTransferInMessage": "No se puede iniciar un depósito bancario desde una cuenta de fondo de ingresos registrada.",
    "electronicFundsTransferOutMessage": "No se puede iniciar un retiro directo desde una cuenta de fondo de ingresos registrada.",
    "internalTransferToMessage": "Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos"
  },
  "LIRA": {
    "electronicFundsTransferInMessage": "No se puede iniciar un depósito bancario desde una cuenta bloqueada.",
    "electronicFundsTransferOutMessage": "Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos",
    "internalTransferToMessage": "Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos"
  },
  "LRSP": {
    "electronicFundsTransferInMessage": "No se puede iniciar un depósito bancario desde una cuenta bloqueada.",
    "electronicFundsTransferOutMessage": "Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos",
    "internalTransferToMessage": "Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos"
  },
  "RLSP": {
    "electronicFundsTransferInMessage": "No se puede iniciar un depósito bancario desde una cuenta bloqueada.",
    "electronicFundsTransferOutMessage": "Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos",
    "internalTransferToMessage": "Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos"
  },
  "RRSP": {
    "electronicFundsTransferOutMessage": "Las transferencias de RRSP suelen ser transferencias a otra cuenta RRSP, retiros para un plan de compra de vivienda o transferencias a un RRIF. Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos"
  },
  "RRSP_SPOUSAL": {
    "electronicFundsTransferOutMessage": "Las transferencias de RRSP suelen ser transferencias a otra cuenta RRSP, retiros para un plan de compra de vivienda o transferencias a un RRIF. Póngase en contacto con el servicio de asistencia para facilitar la transferencia de fondos"
  }
}
